window.onunload = function() {};

screenW = screen.width;
if( navigator.userAgent.search(/Android 2./) != -1) {
	screenW = screen.width/window.devicePixelRatio;
}

screenH = screen.height;
if( navigator.userAgent.search(/Android 2./) != -1) {
	screenH = screen.height/window.devicePixelRatio;
}

if(screenW < 768){
	var meta = document.createElement('meta');
	meta.setAttribute('name', 'viewport');
	meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
	document.getElementsByTagName('head')[0].appendChild(meta);
}

//初期設定/////////////////////////////////////////////////
ready_flag = "false";
load_flag = "false";
ready_load_flag = "false";

//Retina判定/////////////////////////////////////////////////
var retinaSwitch = window.devicePixelRatio;
if(retinaSwitch == 1) {
	retina_flag = "false";
}else if(retinaSwitch == undefined) {
	retina_flag = "false";
}else{
	retina_flag = "true";
}

//タッチパネル判定/////////////////////////////////////////////////
var chkTouch = ('ontouchstart' in window);
if(chkTouch){
	touch_flag = "true";
}else{
	touch_flag = "false";
}

var ua = navigator.userAgent;
var userAgent = window.navigator.userAgent.toLowerCase();
var appVersion = window.navigator.appVersion.toLowerCase();
ie_ver = 100;
if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
	if (appVersion.indexOf("msie 6.") != -1) {
		browser_data = "IE";
		ie_ver = 6;
	}else if (appVersion.indexOf("msie 7.") != -1) {
		browser_data = "IE";
		ie_ver = 7;
	}else if (appVersion.indexOf("msie 8.") != -1) {
		browser_data = "IE";
		ie_ver = 8;
	}else if (appVersion.indexOf("msie 9.") != -1) {
		browser_data = "IE";
		ie_ver = 9;
	}else if (appVersion.indexOf("msie 10.") != -1) {
		browser_data = "IE";
		ie_ver = 10;
	}else if (appVersion.indexOf("msie 11.") != -1) {
		browser_data = "IE";
		ie_ver = 11;
	}else{
		browser_data = "IE";
		ie_ver = 0;
	}
}else if (userAgent.indexOf('chrome') != -1) {
	browser_data = "Chrome";
}else if (userAgent.indexOf('safari') != -1) {
	browser_data = "Safari";
}else if (userAgent.indexOf('firefox') != -1) {
	browser_data = "Firefox";
}else if (userAgent.indexOf('opera') != -1) {
	browser_data = "Opera";
}else{
	browser_data = "Other";
}

isAndroid = (ua.match(/Android/i));
isiPhone = (ua.match(/iPhone/i));
isiPad = (ua.match(/iPad/i));
isFlashInstalled=function(){if(navigator.plugins["Shockwave Flash"]){return true;}try{new ActiveXObject("ShockwaveFlash.ShockwaveFlash");return true;}catch(a){return false;}}();
if(isAndroid) { android_ver = parseFloat(userAgent.substr(userAgent.indexOf('android')+8, 3)) };

if(/iPhone/.test(ua)) {
	ua.match(/iPhone OS (\w+){1,3}/g);
	ios_ver=(RegExp.$1.replace(/_/g, '')+'00').slice(0,3);
} else if(/iPad/.test(ua)) {
	ua.match(/CPU OS (\w+){1,3}/g);
	ios_ver=(RegExp.$1.replace(/_/g, '')+'00').slice(0,3);
}

//スクロール/////////////////////////////////////////////////
$(window).scroll(function(){
	if(ready_flag == "true") scroll_func();
});
function scroll_func(){
	scroll_y = (document.documentElement.scrollTop || document.body.scrollTop);
	scroll_x = (document.documentElement.scrollLeft || document.body.scrollLeft);
	scroll_cont();
}

//リサイズ/////////////////////////////////////////////////
$(window).resize(function(){
   if(ready_flag == "true") resize_func();
});
function resize_func(){
	resize_func2();
	resize_func2();
}
function resize_func2(){
	resize_common();
	resize_cont();
}
resize_mode = "";
function resize_common(){
	resize_mode_prv = resize_mode;
	if($(window).width() > 767){
		resize_mode = "pc";
	}else{
		resize_mode = "sp";
	}
	
	winW = $(window).width();
	winH = $(window).height();
	if(minW == "null"){
		winW2 = winW;
	}else{
		winW2 = Math.max($(window).width(), minW);
	}
	if(minH == "null"){
		winH2 = winH;
	}else{
		winH2 = Math.max($(window).height(), minH);
	}
}

///////////////////////////////////////////////////

$(function() {
	ready_flag = "true";
	scroll_y = (document.documentElement.scrollTop || document.body.scrollTop);
	scroll_x = (document.documentElement.scrollLeft || document.body.scrollLeft);
	
	$('#base').on('touchstart', onTouchStart); //指が触れたか検知
	$('#base').on('touchmove', onTouchMove); //指が動いたか検知
	$('#base').on('touchend', onTouchEnd); //指が離れたか検知
	
	//スワイプ開始時の横方向の座標を格納
	function onTouchStart(event) {
		resize_common();
	}
	
	//スワイプの方向（left／right）を取得
	function onTouchMove(event) {
		resize_common();
	}
	
	function onTouchEnd(event) {
		resize_common();
	}
	
	ready_func();
	if(load_flag == "true") ready_load_func_();
});

$(window).load(function(){
	load_flag = "true";
	load_func();
	if(ready_flag == "true") ready_load_func_();
});

function ready_load_func_(){
	ready_load_flag = "true";
	ready_load_func();
}

///////////////////////////////////////////////////

minW = 1200;
minH = "null";

pagetop_size = 108;

photo_mode = "false";
test_mode = "false";

function resize_cont(){
	if(resize_mode == "pc"){
		//PC
		$("#base").css({"min-width":minW});
		
		winWL = Math.ceil(winW2/2);
		winWR = Math.floor(winW2/2);
		
		$("#base .sec").css({"width":winW2, "height":winH});
		$("#base .sec .subsec").css({"width":winW2, "height":winH});
	}else{
		//SP
		$("#base").css({"min-width":0});
		
		winW2 = winW;
		winWL = winW;
		winWR = winW;
		
		$("#base .sec").css({"width":winW2, "height":"auto"});
		$("#base .sec .subsec").css({"width":winW2, "height":"auto"});
	}
	if(resize_mode_prv != resize_mode){
	}
	
	winWS = winW2/1320;
	winHS = winH/742;
	
	//intro
	if(resize_mode == "pc"){
		$(".intro .subintro .subsubintro p").css({"font-size":4.8*(winWS*0.5+0.5)+"em"});
	}else{
		$(".intro .subintro .subsubintro p").css({"font-size":9.6*winWS+"em"});
	}
	
	//home
	if(resize_mode == "pc"){
		$("#base .home .subsec .bg").css({"width":winW2, "height":winH});
	}else{
		$("#base .home").css({"height":winH});
		$("#base .home .subsec").css({"height":winH});
		$("#base .home .subsec .bg").css({"width":winW2*1.1, "height":winH*0.65});
	}
	
	//concept
	if(resize_mode == "pc"){
		concept_bg_l = 480*winWS;
		concept_bg_img_r = -winH*1040/742/2;
		concept_bg_img_r_max = -(winW2-concept_bg_l-250);
		$("#base .concept .subsec .bg").css({"left":concept_bg_l});
		$("#base .concept .subsec .bg img").css({"height":winH, "right":Math.max(concept_bg_img_r, concept_bg_img_r_max)});
	}else{
		$("#base .concept").css({"height":"auto"});
		$("#base .concept .subsec").css({"height":"auto"});
		
		$("#base .concept .subsec .bg").css({"left":0});
		$("#base .concept .subsec .bg img").css({"height":260, "right":-20});
	}
	
	$("#base .concept .subsec .cont .cont_t").css({"top":90*winHS-10, "right":70*winWS});
	$("#base .concept .subsec .cont .cont_b").css({"bottom":90*winHS, "right":70*winWS});
	
	//phtsec1
	if(resize_mode == "pc"){
		$("#base .phtsec1 .subsec .bg").css({"width":winW2, "height":winH});
	}else{
		$("#base .phtsec1").css({"height":"auto"});
		$("#base .phtsec1 .subsec").css({"height":"auto"});
		
		$("#base .phtsec1 .subsec .bg").css({"width":winW2, "height":winW2});
	}
	
	//feature
	if(resize_mode == "pc"){
		$("#base .feature .subsec .cont_l").css({"width":winWL, "height":winH});
		$("#base .feature .subsec .cont_r").css({"width":winWR, "height":winH});
		
		$("#base .feature1 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*123/10+"em"});
		$("#base .feature2 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*75/10+"em"});
		$("#base .feature3 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*72/10+"em"});
		$("#base .feature4 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*71/10+"em"});
	}else{
		$("#base .feature .subsec .cont_l").css({"width":winWL, "height":"auto"});
		$("#base .feature .subsec .cont_r").css({"width":winWR, "height":"auto"});
		$("#base .feature .subsec .pht").css({"height":winW2});
		$("#base .feature1 .subsec .pht").css({"height":Math.round(winW2*1.2)});
		
		$("#base .feature1 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*123/10*2+"em"});
		$("#base .feature2 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*75/10*2+"em"});
		$("#base .feature3 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*72/10*2+"em"});
		$("#base .feature4 .subsec .pht .phttxt .txt1").css({"font-size":winW2/1320*71/10*2+"em"});
	}
	
	$("#base .feature .subsec .cont_l .phttxt").css({"width":winWL+200});
	$("#base .feature .subsec .cont_r .phttxt").css({"width":winWR+200});
	
	//phtsec2
	if(resize_mode == "pc"){
		$("#base .phtsec2 .subsec .bg").css({"width":winW2, "height":winH});
	}else{
		$("#base .phtsec2").css({"height":"auto"});
		$("#base .phtsec2 .subsec").css({"height":"auto"});
		
		$("#base .phtsec2 .subsec .bg").css({"width":winW2, "height":winW2});
	}
	
	//photo
	if(resize_mode == "pc"){
		winW1_4 = Math.ceil(winWL/2);
		winW2_4 = Math.floor(winWL/2);
		winW3_4 = Math.ceil(winWR/2);
		winW4_4 = Math.floor(winWR/2);
		winH1_3 = Math.round(winH/3);
		winH2_3 = Math.round(winH*2/3)-winH1_3;
		winH3_3 = winH-winH1_3-winH2_3;
		for(i=0; i<12; i++){
			if(i%4==0){
				$("#base .photo .subsec .pht:eq("+i+")").css({"width":winW1_4, "left":0});
			}if(i%4==1){
				$("#base .photo .subsec .pht:eq("+i+")").css({"width":winW2_4, "left":winW1_4});
			}if(i%4==2){
				$("#base .photo .subsec .pht:eq("+i+")").css({"width":winW3_4, "left":winW1_4+winW2_4});
			}if(i%4==3){
				$("#base .photo .subsec .pht:eq("+i+")").css({"width":winW4_4, "left":winW1_4+winW2_4+winW3_4});
			}
			
			if(Math.floor(i/4)==0){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":winH1_3, "top":0});
			}if(Math.floor(i/4)==1){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":winH2_3, "top":winH1_3});
			}if(Math.floor(i/4)==2){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":winH3_3, "top":winH1_3+winH2_3});
			}
		}
	}else{
		$("#base .photo").css({"height":Math.round(winW2/2*2/3)*6});
		$("#base .photo .subsec").css({"height":Math.round(winW2/2*2/3)*6});
		
		for(i=0; i<12; i++){
			if(i%2==0){
				$("#base .photo .subsec .pht:eq("+i+")").css({"width":Math.ceil(winW2/2), "left":0});
			}if(i%2==1){
				$("#base .photo .subsec .pht:eq("+i+")").css({"width":Math.floor(winW2/2), "left":Math.ceil(winW2/2)});
			}
			
			if(Math.floor(i/2)==0){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":Math.round(winW2/2*2/3), "top":0});
			}if(Math.floor(i/2)==1){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":Math.round(winW2/2*2/3), "top":Math.round(winW2/2*2/3)});
			}if(Math.floor(i/2)==2){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":Math.round(winW2/2*2/3), "top":Math.round(winW2/2*2/3)*2});
			}if(Math.floor(i/2)==3){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":Math.round(winW2/2*2/3), "top":Math.round(winW2/2*2/3)*3});
			}if(Math.floor(i/2)==4){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":Math.round(winW2/2*2/3), "top":Math.round(winW2/2*2/3)*4});
			}if(Math.floor(i/2)==5){
				$("#base .photo .subsec .pht:eq("+i+")").css({"height":Math.round(winW2/2*2/3), "top":Math.round(winW2/2*2/3)*5});
			}
		}
	}
	
	
	
	
	//footer
	if(resize_mode == "pc"){
		$("#base .footer .subsec .cont_t .cont_l").css({"width":winW2-327});
		$("#base .footer .subsec .cont_t .cont_l .navi .tbl .tr .navi_r").css({"width":winW2-327-50-170-35});
		$("#base .footer .subsec .cont_t .cont_r .sns").css({"width":108, "height":108});
		$("#base .footer .subsec .cont_b").css({"width":winW2});
	}else{
		$("#base .footer .subsec .cont_t .cont_l").css({"width":"auto"});
		$("#base .footer .subsec .cont_t .cont_l .navi .tbl .tr .navi_r").css({"width":"auto"});
		
		sns1_w = Math.round((winW2-5)*1/6);
		sns2_w = Math.round((winW2-5)*2/6)-sns1_w;
		sns3_w = Math.round((winW2-5)*3/6)-sns1_w-sns2_w;
		sns4_w = Math.round((winW2-5)*4/6)-sns1_w-sns2_w-sns3_w;
		sns5_w = Math.round((winW2-5)*5/6)-sns1_w-sns2_w-sns3_w-sns4_w;
		sns6_w = Math.round((winW2-5)*6/6)-sns1_w-sns2_w-sns3_w-sns4_w-sns5_w;
		$("#base .footer .subsec .cont_t .cont_r .sns:eq(0)").css({"width":sns1_w, "height":sns1_w});
		$("#base .footer .subsec .cont_t .cont_r .sns:eq(1)").css({"width":sns2_w, "height":sns1_w});
		$("#base .footer .subsec .cont_t .cont_r .sns:eq(2)").css({"width":sns3_w, "height":sns1_w});
		$("#base .footer .subsec .cont_t .cont_r .sns:eq(3)").css({"width":sns4_w, "height":sns1_w});
		$("#base .footer .subsec .cont_t .cont_r .sns:eq(4)").css({"width":sns5_w, "height":sns1_w});
		$("#base .footer .subsec .cont_t .cont_r .sns:eq(5)").css({"width":sns6_w, "height":sns1_w});
		
		$("#base .footer .subsec .cont_b").css({"width":"auto"});
	}
	$("#base .footer .subsec .cont_t").css({"width":winW2});
	
	//photomodal
	if(resize_mode == "pc"){
		photomodal_l = Math.round(80*Math.max(winWS,1));
		photomodal_t = Math.round(50*Math.max(winHS,1));
	}else{
		photomodal_l = 0;
		photomodal_t = Math.round(80*Math.max(winHS,1));
	}
	$(".photomodal").css({"width":winW2, "height":winH});
	$(".photomodal .subsec").css({"width":winW2, "height":winH});
	$(".photomodal .subsec .bg").css({"width":winW2, "height":winH});
	
	photomodal_w = winW2-photomodal_l*2;
	photomodal_h = winH-photomodal_t*2;
	$(".photomodal .subsec .pht").css({"width":photomodal_w, "height":photomodal_h, "left":photomodal_l, "top":photomodal_t});
	$(".photomodal .subsec .pht .subpht .subsubpht").css({"width":Math.min(photomodal_w, Math.round(photomodal_h*3/2)), "height":Math.min(photomodal_h, Math.round(photomodal_w*2/3))});
	$(".photomodal .subsec .pht .subpht .subsubpht img").css({"width":Math.min(photomodal_w, Math.round(photomodal_h*3/2)), "height":Math.min(photomodal_h, Math.round(photomodal_w*2/3))});
	
	//pagetop
	if(resize_mode == "pc"){
		pagetop_size = 108;
	}else{
		pagetop_size = sns6_w+1;
	}
	$("#base .footer .subsec .cont_b .cont_l").css({"height":pagetop_size});
	$("#base .footer .subsec .cont_b .cont_r").css({"height":pagetop_size});
	$("#base .pagetop .pagetop2 img").css({"width":pagetop_size, "height":pagetop_size});
	
	scroll_cont();
}

function scroll_cont(){
	//$("#base .pagetop").css({"top":winH});
	$("#base .pagetop").css({"bottom":0});
	if(photo_mode == "false"){
		$("#base .pagetop .pagetop2").css({"top":Math.max(-scroll_y, -pagetop_size)});
	}else if(photo_mode == "false"){
		$("#base .pagetop .pagetop2").css({"top":Math.max(-photo_scroll_y, -pagetop_size)});
	}
	
	ctr_chk();
}

ready_intro_flag = "false";
function ready_intro_func(){
	$(".intro").css({"z-index":1001});
	$(".intro .subintro .subsubintro .introcv").delay(0.5*1000).animate({"width":"100%"},{duration:0.6*1000, easing:"easeInOutQuart", complete:function(){
		$(".intro .subintro .subsubintro p").stop().animate({"opacity":1.0},{duration:0});
		$(".intro .subintro .subsubintro .introcv").css({"left":"auto", "right":0});
		$(".intro .subintro .subsubintro .introcv").delay(0.0*1000).animate({"width":0},{duration:0.6*1000, easing:"easeInOutQuart", complete:function(){
			setTimeout(function(){
				ready_intro_flag = "true";
				if(test_mode == "false"){
				if(ready_load_flag == "true") intro_func();
				}
			}, 0.0*1000);
			
		}});
	}});
}

function intro_func(){
	if(touch_flag == "false"){
		$("#ancnavi").css({"left":winW2*1.5, "top":winH*1.5});
	}else{
		$("#ancnavi").css({"display":"none"});
	}
	
	$(".intro").fadeOut({duration:1.8*1000, easing:"easeInOutQuart"});
	$("#cover").fadeOut({duration:1.8*1000, easing:"easeInOutQuart", complete:function(){
		$("#base").css({"position":"static", "left":0, "top":0});
		resize_func();
		
		$("#base .home .subsec .str").delay(0.2*1000).animate({"opacity":1.0},{duration:0.5*1000, easing:"linear"});
		$("#base .home .subsec .strider").delay(0.2*1000).animate({"opacity":1.0},{duration:0.5*1000, easing:"linear"});
		$("#base .home .subsec .scrolltxt").delay(0.2*1000).animate({"opacity":1.0},{duration:0.5*1000, easing:"linear"});
		$("#base .home .subsec .scrollbar").delay(0.2*1000).animate({"opacity":1.0},{duration:0.5*1000, easing:"linear"});
		$("#base .home .subsec .sns").delay(0.2*1000).animate({"opacity":1.0},{duration:0.5*1000, easing:"linear"});
		$("#base .home .subsec .cp").delay(0.2*1000).animate({"opacity":1.0},{duration:0.5*1000, easing:"linear", complete:function(){
			if(touch_flag == "false"){
				top_click_chase();
			}
		}});
		
		
	}});
	TweenLite.to($("#base .home .subsec .bg"),10.0,{scale:1.0,ease:Quad.easeOut,delay:0});
	home_scroll();
}

function ready_func(){
	for(i=0; i<11; i++){
		$("#base .spec .subsec .cont_pc .cont_l dl:eq("+i+") dt").html($("#base .spec .subsec .cont_sp dl:eq("+(i*2)+") dt").html());
		$("#base .spec .subsec .cont_pc .cont_l dl:eq("+i+") dd").html($("#base .spec .subsec .cont_sp dl:eq("+(i*2)+") dd").html());
		$("#base .spec .subsec .cont_pc .cont_r dl:eq("+i+") dt").html($("#base .spec .subsec .cont_sp dl:eq("+(i*2+1)+") dt").html());
		$("#base .spec .subsec .cont_pc .cont_r dl:eq("+i+") dd").html($("#base .spec .subsec .cont_sp dl:eq("+(i*2+1)+") dd").html());
	}
	for(i=11; i<17; i++){
		$("#base .spec .subsec .cont_pc .cont_l dl:eq("+i+") dt").html($("#base .spec .subsec .cont_sp dl:eq("+(11+i)+") dt").html());
		$("#base .spec .subsec .cont_pc .cont_l dl:eq("+i+") dd").html($("#base .spec .subsec .cont_sp dl:eq("+(11+i)+") dd").html());
	}
	$("#base .spec .subsec .cont_pc .cont_r dl:eq(11) dt").html($("#base .spec .subsec .cont_sp dl:eq(28) dt").html());
	$("#base .spec .subsec .cont_pc .cont_r dl:eq(11) dd").html($("#base .spec .subsec .cont_sp dl:eq(28) dd").html());
	$("#base .spec .subsec .cont_pc .cont_r dl:eq(12) dt").html($("#base .spec .subsec .cont_sp dl:eq(29) dt").html());
	$("#base .spec .subsec .cont_pc .cont_r dl:eq(12) dd").html($("#base .spec .subsec .cont_sp dl:eq(29) dd").html());
	
	$("#ancnavi .subnavi .arw").append('<div class="bd"></div>');
	
	$(".intro .subintro .subsubintro p").stop().animate({"opacity":0.0},{duration:0});
	
	$("#base .home .subsec .str").stop().animate({"opacity":0.0},{duration:0});
	$("#base .home .subsec .strider").stop().animate({"opacity":0.0},{duration:0});
	$("#base .home .subsec .scrolltxt").stop().animate({"opacity":0.0},{duration:0});
	$("#base .home .subsec .scrollbar").stop().animate({"opacity":0.0},{duration:0});
	$("#base .home .subsec .sns").stop().animate({"opacity":0.0},{duration:0});
	$("#base .home .subsec .cp").stop().animate({"opacity":0.0},{duration:0});
	TweenLite.to($("#base .home .subsec .bg"),0,{scale:105/100,ease:Quad.easeOut,delay:0});
	
	$("#base .home .subsec .strider img").click(function(){
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.4},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#base .home .subsec .sns li img").click(function(){
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.4},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#base .photo .subsec .pht .subpht").stop().animate({"opacity":0.0},{duration:0});
	
	$("#base .photo .subsec .pht").css({"cursor":"pointer"});
	$("#base .photo .subsec .pht").click(function(){
		photo_mode = "true";
		photo_now = $("#base .photo .subsec .pht").index(this);
		photo_scroll_x = scroll_x;
		photo_scroll_y = scroll_y;
		$("#base").css({"position":"fixed", "left":-photo_scroll_x, "top":-photo_scroll_y});
		
		$(".photomodal .subsec .pht .subpht .subsubpht").html("");
		$(".photomodal .subsec .bg").stop().animate({"opacity":0.0},{duration:0});
		$(".photomodal .subsec .prv").stop().animate({"opacity":0.0},{duration:0});
		$(".photomodal .subsec .nxt").stop().animate({"opacity":0.0},{duration:0});
		$(".photomodal .subsec .close").stop().animate({"opacity":0.0},{duration:0});
		$(".photomodal").css({"display":"block"});
		$(".photomodal .subsec .bg").stop().animate({"opacity":1.0},{duration:0.3*1000, easing:"linear", complete:function(){ photomodal_chg(); }});
		$(".photomodal .subsec .prv").stop().animate({"opacity":1.0},{duration:0.3*1000, easing:"linear"});
		$(".photomodal .subsec .nxt").stop().animate({"opacity":1.0},{duration:0.3*1000, easing:"linear"});
		$(".photomodal .subsec .close").stop().animate({"opacity":1.0},{duration:0.3*1000, easing:"linear"});
		
		resize_func();
	}).mouseenter(function(){
		$(this).find(".subpht").stop().animate({"opacity":1.0},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).find(".subpht").stop().animate({"opacity":0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#base .rakuten .subsec .bg_o").stop().animate({"opacity":0.0},{duration:0});
	
	$("#base .rakuten .subsec").click(function(){
	}).mouseenter(function(){
		$(this).find(".bd_t .subbd").stop().css({"width":0});
		$(this).find(".bd_t .subbd").stop().animate({"width":"100%"},{duration:0.7*1000, easing:"easeInOutQuart"});
		$(this).find(".bd_b .subbd").stop().css({"width":0});
		$(this).find(".bd_b .subbd").stop().animate({"width":"100%"},{duration:0.7*1000, easing:"easeInOutQuart"});
		$(this).find(".bd_l .subbd").stop().css({"height":0});
		$(this).find(".bd_l .subbd").stop().animate({"height":"100%"},{duration:0.7*1000, easing:"easeInOutQuart"});
		$(this).find(".bd_r .subbd").stop().css({"height":0});
		$(this).find(".bd_r .subbd").stop().animate({"height":"100%"},{duration:0.7*1000, easing:"easeInOutQuart"});
		
		$("#base .rakuten .subsec .bg_o").stop().animate({"opacity":1.0},{duration:0});
		$("#base .rakuten .subsec .bg_o").stop().animate({"opacity":0.4},{duration:0.7*1000, easing:"linear"});
	}).mouseleave(function(){
		$("#base .rakuten .subsec .bg_o").stop().animate({"opacity":0.0},{duration:0.5*1000, easing:"linear"});
	});
	
	$(".photomodal .subsec .bg").click(function(){
		photomodal_close();
	});
	
	$(".photomodal .subsec .pht .subpht .bgcv").click(function(){
		photomodal_close();
	});
	
	$(".photomodal .subsec .prv").css({"cursor":"pointer"});
	$(".photomodal .subsec .prv").click(function(){
		photo_now = (photo_now+12-1)%12;
		photomodal_chg();
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.5},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$(".photomodal .subsec .nxt").css({"cursor":"pointer"});
	$(".photomodal .subsec .nxt").click(function(){
		photo_now = (photo_now+1)%12;
		photomodal_chg();
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.5},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$(".photomodal .subsec .close").css({"cursor":"pointer"});
	$(".photomodal .subsec .close").click(function(){
		photomodal_close();
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.5},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#base .footer .subsec .cont_t .cont_r .sns .bg").animate({"opacity":0.0},{duration:0});
	$("#base .footer .subsec .cont_t .cont_r .sns .txt").animate({"opacity":0.0},{duration:0});
	
	$("#base .footer .subsec .cont_t .cont_r .sns").click(function(){
	}).mouseenter(function(){
		$(this).find(".bg").stop().animate({"opacity":1.0},{duration:0.1*1000, easing:"easeOutQuad"});
		$(this).find("img").stop().animate({"opacity":0.3},{duration:0.1*1000, easing:"easeOutQuad"});
		$(this).find(".txt").stop().animate({"opacity":1.0},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).find(".bg").stop().animate({"opacity":0},{duration:0.15*1000, easing:"linear"});
		$(this).find("img").stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
		$(this).find(".txt").stop().animate({"opacity":0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#base .footer .subsec .cont_b .cont_l img").click(function(){
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.4},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#base .pagetop .pagetop2 img").css({"cursor":"pointer"});
	$("#base .pagetop .pagetop2 img").click(function(){
		var mov_dst = scroll_y;
		$("html,body").animate({scrollTop:0},{duration:0.5*(mov_dst*0.2 + 1000*0.8), easing:"easeOutQuart"});
		return false;
	}).mouseenter(function(){
		$(this).stop().animate({"opacity":0.5},{duration:0.1*1000, easing:"easeOutQuad"});
	}).mouseleave(function(){
		$(this).stop().animate({"opacity":1.0},{duration:0.15*1000, easing:"linear"});
	});
	
	$("#ancnavi .subnavi").click(function(){
		if(arow_mode == "nxt"){
			if($("#base .concept").offset().top > scroll_y){
				trg_y = $("#base .concept").offset().top;
			}else if($("#base .phtsec1").offset().top > scroll_y){
				trg_y = $("#base .phtsec1").offset().top;
			}else if($("#base .feature1").offset().top > scroll_y){
				trg_y = $("#base .feature1").offset().top;
			}else if($("#base .feature2").offset().top > scroll_y){
				trg_y = $("#base .feature2").offset().top;
			}else if($("#base .feature3").offset().top > scroll_y){
				trg_y = $("#base .feature3").offset().top;
			}else if($("#base .feature4").offset().top > scroll_y){
				trg_y = $("#base .feature4").offset().top;
			}else if($("#base .phtsec2").offset().top > scroll_y){
				trg_y = $("#base .phtsec2").offset().top;
			}else if($("#base .photo").offset().top > scroll_y){
				trg_y = $("#base .photo").offset().top;
			}else if($("#base .spec").offset().top > scroll_y){
				trg_y = $("#base .spec").offset().top;
			}else{
				trg_y = Math.min($("#base .rakuten").offset().top, $("#base .footer").offset().top+$("#base .footer").height()-winH);
			}
		}else{
			if($("#base .spec").offset().top < scroll_y){
				trg_y = $("#base .spec").offset().top;
			}else if($("#base .photo").offset().top < scroll_y){
				trg_y = $("#base .photo").offset().top;
			}else if($("#base .phtsec2").offset().top < scroll_y){
				trg_y = $("#base .phtsec2").offset().top;
			}else if($("#base .feature4").offset().top < scroll_y){
				trg_y = $("#base .feature4").offset().top;
			}else if($("#base .feature3").offset().top < scroll_y){
				trg_y = $("#base .feature3").offset().top;
			}else if($("#base .feature2").offset().top < scroll_y){
				trg_y = $("#base .feature2").offset().top;
			}else if($("#base .feature1").offset().top < scroll_y){
				trg_y = $("#base .feature1").offset().top;
			}else if($("#base .phtsec1").offset().top < scroll_y){
				trg_y = $("#base .phtsec1").offset().top;
			}else if($("#base .concept").offset().top < scroll_y){
				trg_y = $("#base .concept").offset().top;
			}else{
				trg_y = 0;
			}
		}
		
		var mov_dst = Math.abs(scroll_y-trg_y);
		$("html,body").animate({scrollTop:trg_y},{duration:0.5*(mov_dst*0.2 + 1000*0.8), easing:"easeOutQuart"});
		return false;
	});
	
	resize_func();
	
	x_mouse = winW2/2;
	y_mouse = winH/2;
	//カーソル位置取得
	$(window).on('mousemove', function(e) {
       /* $('#screenX').text(e.screenX);
        $('#screenY').text(e.screenY);
 
        $('#pageX').text(e.pageX);
        $('#pageY').text(e.pageY);
 
        $('#clientX').text(e.clientX);
        $('#clientY').text(e.clientY);
 
        $('#offsetX').text(e.offsetX);
        $('#offsetY').text(e.offsetY);*/
		x_mouse = e.clientX;
		y_mouse = e.clientY;
		
		ctr_chk();
    });
	
	ready_intro_func();
}

function load_func(){
}

function ready_load_func(){
	resize_func();
	if(test_mode == "true"){
		$(".intro").css({"display":"none"});
		$("#cover").css({"display":"none"});
		intro_func();
	}else{
		if(ready_intro_flag == "true") intro_func();
	}
}

function home_scroll(){
	home_scroll_si = setInterval(function(){
		$("#base .home .subsec .scrollbar .bar").css({"bottom":"auto", "top":0});
		$("#base .home .subsec .scrollbar .bar").stop().animate({"height":"100%"},{duration:0.8*1000, easing:"easeInQuart", complete:function(){
			$("#base .home .subsec .scrollbar .bar").css({"top":"auto", "bottom":0});
			$("#base .home .subsec .scrollbar .bar").stop().animate({"height":0},{duration:0.8*1000, easing:"easeOutQuart", complete:function(){
			}});
		}});
	}, 3.0*1000);
}


function photomodal_chg(){
	$(".photomodal .subsec .pht .subpht .subsubpht").html('');
	$(".photomodal .subsec .pht").stop().animate({"opacity":0.0},{duration:0});
	$(".photomodal .subsec .pht .subpht .subsubpht").html('<img src="">');
	
	$(".photomodal .subsec .pht .subpht .subsubpht img").bind('load', function(){
		$(".photomodal .subsec .pht .subpht .subsubpht img").css({"width":Math.min(photomodal_w, Math.round(photomodal_h*3/2)), "height":Math.min(photomodal_h, Math.round(photomodal_w*2/3))});
		$(".photomodal .subsec .pht").stop().animate({"opacity":1.0},{duration:1.5*1000, easing:"easeInOutQuart"});
	});
	
	$(".photomodal .subsec .pht .subpht .subsubpht img").attr("src", "img/photo/"+(photo_now+1)+"z.jpg");
}


function photomodal_close(){
	$("#base").css({"position":"static", "left":0, "top":0});
	$("html,body").animate({scrollTop:photo_scroll_y, scrollLeft:photo_scroll_x},{duration:0});
	
	$(".photomodal").css({"display":"none"});
	
	photo_mode = "false";
	
	resize_func();
}

top_click_flag = "true";
function top_click_chase(){
	top_click_settimer = setTimeout(function(){
		//$("#base .work .list .test").html(x_mouse+":"+y_mouse);
		mov_x = (x_mouse-$("#ancnavi").position().left)/5;
		mov_y = (y_mouse-$("#ancnavi").position().top)/5;
		
		mov_x_aj = Math.abs(mov_x)-20;
		if (mov_x_aj<0.1) {
			mov_x_aj = 0;
		} else {
			mov_x_aj *= Math.abs(mov_x)/mov_x;
		}
		
		mov_y_aj = Math.abs(mov_y)-20;
		if (mov_y_aj<0.1) {
			mov_y_aj = 0;
		} else {
			mov_y_aj *= Math.abs(mov_y)/mov_y;
		}
		
		$("#ancnavi").css({
			"left":$("#ancnavi").position().left+mov_x_aj,
			"top":$("#ancnavi").position().top+mov_y_aj
		});
		
		if(top_click_flag == "true"){
			top_click_chase();
		}else{
		}
	}, 1000/30);
	
	ctr_chk();
}

arow_mode = "nxt";
function ctr_chk(){
	if(scroll_y <= 1){
		//下
		if($("#ancnavi .subnavi .arw").hasClass("rfc")){
			if(arow_mode == "prv"){
				arow_mode = "nxt";
				$("#ancnavi .subnavi .arw").removeClass("rfc");
			}
		}
	}else if(scroll_y >= $("#base .footer").offset().top+$("#base .footer").height()-winH-1){
		//上
		if($("#ancnavi .subnavi .arw").hasClass("rfc")){
		}else{
			if(arow_mode == "nxt"){
				arow_mode = "prv";
				$("#ancnavi .subnavi .arw").addClass("rfc");
			}
		}
	}else if(y_mouse > winH/2){
		//下
		if($("#ancnavi .subnavi .arw").hasClass("rfc")){
			if(arow_mode == "prv"){
				arow_mode = "nxt";
				$("#ancnavi .subnavi .arw").removeClass("rfc");
			}
		}
	}else if(y_mouse <= winH/2){
		//上
		if($("#ancnavi .subnavi .arw").hasClass("rfc")){
		}else{
			if(arow_mode == "nxt"){
				arow_mode = "prv";
				$("#ancnavi .subnavi .arw").addClass("rfc");
			}
		}
	}
}